<div class="page-container">
  <ng-content />
</div>
